const Tags = {
  parts: ['container', 'label', 'closeButton'],
  baseStyle: {},
  sizes: {},
  variants: {
    'filter-tags': {
      container: {
        py: 1,
        px: 2,
        color: 'dark',
        bg: 'light',
        boxShadow: 'none',
        mb: { base: 1, md: 0 },
        mr: { base: 1, md: 0 },
      },
      label: {
        fontSize: 'sm',
      },
      closeButton: {
        bg: 'lighterPrimary',
        color: 'dark',
      },
    },
  },
  defaultProps: {},
}

export default Tags
